class Keys {
    static sidebarStatusKey = 'vue3-typescript-admin-sidebarStatusKey'
    static languageKey = 'vue3-typescript-admin-languageKey'
    static sizeKey = 'vue3-typescript-admin-sizeKey'
    static tokenKey = 'vue3-typescript-admin-access-token'
    static aseKey = 'vue3-typescript-admin-ase-key'

    // 生产环境
    static dsUrl = 'https://www.dangaoss.com'
    static baseUrl = '//trade.dangaoss.cn'   // 生产环境地址
    static uploadUrl = '//trade.dangaoss.cn/cake/setSpecsImg?x-oss-process=style/specs&oss_file='  // 图片上传地址：需要传入 oss_file 值，即文件上传文件夹名称
    static pdfUploadUrl = '//trade.dangaoss.cn/channel/up_channel_source'  // 图片上传地址：需要传入 oss_file 值，即文件上传文件夹名称
    static invoiceUploadUrl = '//trade.dangaoss.cn/invoice/uploadInvoice'  // 图片上传地址：需要传入 oss_file 值，即文件上传文件夹名称
    static bankUploadUrl = '//trade.dangaoss.cn/admin/channel/upload_bank_receipt'  // 银行回单图片上传地址：需要传入 oss_file 值，即文件上传文件夹名称

    // 测试环境
    // static dsUrl = 'https://dev.dangaoss.cn'
    // static baseUrl = '//devtrade.dangaoss.cn'   // 测试环境地址
    // static uploadUrl = '//devtrade.dangaoss.cn/cake/setSpecsImg?x-oss-process=style/specs&oss_file='  // 图片上传地址：需要传入 oss_file 值，即文件上传文件夹名称
    // static pdfUploadUrl = '//devtrade.dangaoss.cn/channel/up_channel_source'  // 图片上传地址：需要传入 oss_file 值，即文件上传文件夹名称
    // static invoiceUploadUrl = '//devtrade.dangaoss.cn/invoice/uploadInvoice'  // 图片上传地址：需要传入 oss_file 值，即文件上传文件夹名称
    // static bankUploadUrl = '//devtrade.dangaoss.cn/admin/channel/upload_bank_receipt'  // 银行回单图片上传地址：需要传入 oss_file 值，即文件上传文件夹名称

    // 预上线环境
    // static dsUrl = 'https://dev.dangaoss.cn'
    // static baseUrl = '//admintrade.dangaoss.cn'   // 测试环境地址
    // static uploadUrl = '//admintrade.dangaoss.cn/cake/setSpecsImg?x-oss-process=style/specs&oss_file='  // 图片上传地址：需要传入 oss_file 值，即文件上传文件夹名称
    // static pdfUploadUrl = '//admintrade.dangaoss.cn/channel/up_channel_source'  // 图片上传地址：需要传入 oss_file 值，即文件上传文件夹名称
    // static invoiceUploadUrl = '//admintrade.dangaoss.cn/invoice/uploadInvoice'  // 图片上传地址：需要传入 oss_file 值，即文件上传文件夹名称
    // static bankUploadUrl = '//admintrade.dangaoss.cn/admin/channel/upload_bank_receipt'  // 银行回单图片上传地址：需要传入 oss_file 值，即文件上传文件夹名称
}

export default Keys
